import type { JSX } from "solid-js";

/**
 * Header wordmark. Serif-italic "fastdiff" with a small sans-serif caption
 * beneath. `currentColor` follows the surrounding text color so the logo
 * adapts to the theme.
 *
 * The illuminated full logo is kept at `apps/web/public/og-image.svg` for
 * og:image / social-share use.
 */
export function FastdiffLogo(): JSX.Element {
  return (
    <svg
      class="fd-logo"
      viewBox="0 0 200 70"
      role="img"
      aria-label="fastdiff"
      fill="currentColor"
    >
      <text
        x="0"
        y="44"
        font-family="'EB Garamond', 'Cormorant Garamond', Garamond, 'Times New Roman', serif"
        font-size="48"
        font-style="italic"
        letter-spacing="-0.01em"
      >fastdiff</text>
      <text
        x="2"
        y="62"
        font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        font-size="9"
        fill-opacity="0.6"
        letter-spacing="0.3em"
      >DIFF · RE·MADE</text>
    </svg>
  );
}
